module.exports = __webpack_public_path__ + "img/User-Inactive.52f690d.svg";